import { env } from '@ivy/fts/envInfo/envInfo'
import axios from 'axios'
import { Toast } from 'mint-ui'
env.init()

// 获取分享信息
export async function share(test_id?) {
  let { data } = await requireGet('/api/m-course/lexile/getShareInfo', {
    test_id,
  })
  return await env.share(data)
}
// 兼容app内嵌h5,Get请求
export async function requireGet(url, data?, config?) {
  const info = await env.getInfo()
  if (env.type === 'web') {
    return Toast('请在App中打开')
  }
  if (env.type === 'ivydad') {
    return axios.get(url, {
      params: {
        ...data,
        ...info.publicParams,
      },
      ...config,
    })
  }
  return axios.get(url, {
    params: {
      ...data,
    },
    ...config,
  })
}
// 兼容app内嵌h5,Post请求
export async function requirePost(url, data, config?) {
  const info = await env.getInfo()
  if (env.type === 'web') {
    return Toast('请在App中打开')
  }
  if (env.type === 'ivydad') {
    return axios.post(url, { ...data, ...info.publicParams }, config)
  }
  return axios.post(url, data, config)
}

// 埋点接口
export async function getUpload(module: string, p1?, p2?) {
  try {
    await requireGet(
      '/api/stat/upload/lexile',
      {
        module,
        p1,
        p2,
      },
      {
        disableAlert: true,
      }
    )
  } catch (error) {
    console.log(error)
  }
}
